import { MagnifyingGlassIcon } from '@adsk/alloy-react-icon';

const FilterSearchIcon = () => <MagnifyingGlassIcon height="15px" className="FilterSearchIcon" />;

FilterSearchIcon.displayName = 'FilterSearchIcon';

export default FilterSearchIcon;
